import { useTranslation } from 'react-i18next';
import PriorityDot from './PriorityDot'
import StatusBadge from './StatusBadge';
import PermissionGate from '../../../components/PermissionGate';
import { formatCurrency, formatDate } from '../../regureStyles';

const Header = ({
  S,
  history,
  claim,
  riskSignals,
  SEVERITY_COLORS,
  setShowSignals,
  setReggieOpen,
  reggieOpen,
  canChangeStatus,
  userRole,
  userData,
  setShowStatusModal,
  canModifyClaim,
  setShowAssignModal,
  setShowEditModal,
  showSignals,
}) => {
  const { t } = useTranslation();
  return (
    <header
      style={{ padding: '20px 32px', borderBottom: `1px solid ${S.borderLight}`, background: 'rgba(255,255,255,0.8)', backdropFilter: 'blur(20px)', flexShrink: 0 }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
          <button
            onClick={() => history.push('/claims')}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: 34,
              height: 34,
              borderRadius: 8,
              border: `1px solid ${S.borderLight}`,
              background: '#fff',
              cursor: 'pointer',
            }}
          >
            <svg width='16' height='16' viewBox='0 0 24 24' fill='none' stroke={S.textSecondary} strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
              <line x1='19' y1='12' x2='5' y2='12' />
              <polyline points='12 19 5 12 12 5' />
            </svg>
          </button>
          <div>
            <div style={{ fontSize: 12, color: S.textMuted, display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2 }}>
              {t('screens.claimsScreen.operations')}
              <svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke={S.textMuted} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                <polyline points='9 18 15 12 9 6' />
              </svg>
              {t('screens.claimsScreen.breadcrumbClaims')}
              <svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke={S.textMuted} strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
                <polyline points='9 18 15 12 9 6' />
              </svg>
              <span style={{ color: S.textPrimary, fontWeight: 500 }}>{claim.id}</span>
            </div>
            <div style={{ fontSize: 20, fontWeight: 700, color: S.textPrimary }}>{claim.claimantDisplay || claim.claimant?.name || '—'}</div>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <StatusBadge status={claim.status} />
          <PriorityDot priority={claim.priority} />
          {riskSignals.length > 0 &&
            (() => {
              const topSeverity = ['critical', 'high', 'medium', 'low'].find(s => riskSignals.some(r => r.severity === s));
              const color = SEVERITY_COLORS[topSeverity] || '#64748b';
              return (
                <button
                  onClick={() => setShowSignals(v => !v)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    padding: '6px 12px',
                    background: color + '12',
                    border: `1px solid ${color}40`,
                    borderRadius: 8,
                    fontSize: 12,
                    fontWeight: 700,
                    color,
                    cursor: 'pointer',
                    transition: 'all 0.15s',
                  }}
                >
                  <span style={{ width: 7, height: 7, borderRadius: '50%', background: color }} />
                  {t('screens.claimsScreen.detail.activeSignal', { count: riskSignals.length })}
                </button>
              );
            })()}
          {userData?.aiEnabled && (
            <button
              onClick={() => setReggieOpen(o => !o)}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '8px 16px',
                background: reggieOpen ? `linear-gradient(135deg, ${S.burgundy}, ${S.burgundy2})` : '#fff',
                color: reggieOpen ? '#fff' : S.burgundy,
                border: `1px solid ${reggieOpen ? 'transparent' : 'rgba(128,0,32,0.3)'}`,
                borderRadius: 8,
                fontSize: 12,
                fontWeight: 700,
                cursor: 'pointer',
                transition: 'all 0.15s',
              }}
            >
              <span
                style={{
                  width: 20,
                  height: 20,
                  borderRadius: 6,
                  background: reggieOpen ? 'rgba(255,255,255,0.2)' : `linear-gradient(135deg, ${S.burgundy}, ${S.burgundy2})`,
                  color: '#fff',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 11,
                  fontWeight: 800,
                }}
              >
                R
              </span>
              {t('screens.claimsScreen.detail.askReggie')}
            </button>
          )}
          <PermissionGate resource='claims' action='update'>
            <button
              onClick={() => setShowStatusModal(true)}
              style={{
                padding: '8px 16px',
                background: `linear-gradient(135deg, ${S.burgundy}, ${S.burgundy2})`,
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                fontSize: 12,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              {t('screens.claimsScreen.detail.changeStatus')}
            </button>
          </PermissionGate>
          <PermissionGate resource='claims' action='assign'>
            <button
              onClick={() => setShowAssignModal(true)}
              style={{
                padding: '8px 16px',
                background: '#f0f4f8',
                color: S.textPrimary,
                border: `1px solid ${S.borderLight}`,
                borderRadius: 8,
                fontSize: 12,
                fontWeight: 600,
                cursor: 'pointer',
              }}
            >
              {t('screens.claimsScreen.detail.assignClaim')}
            </button>
          </PermissionGate>
          <PermissionGate resource='claims' action='update'>
            <button
              onClick={() => setShowEditModal && setShowEditModal(true)}
              title={t('screens.claimsScreen.detail.editClaimTitle')}
              style={{ padding: '7px 14px', background: '#fff', border: `1px solid ${S.borderLight}`, borderRadius: 8, cursor: 'pointer', fontSize: 12, fontWeight: 600, color: S.textSecondary }}
            >
              {t('screens.claimsScreen.detail.edit')}
            </button>
          </PermissionGate>
        </div>
      </div>

      {/* Risk signals panel */}
      {showSignals && riskSignals.length > 0 && (
        <div style={{ background: '#fff9f9', border: '1px solid rgba(220,38,38,0.2)', borderRadius: 12, padding: '14px 18px', marginBottom: 12 }}>
          <div style={{ fontSize: 12, fontWeight: 700, color: '#dc2626', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 10 }}>{t('screens.claimsScreen.detail.activeRiskSignals')}</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {riskSignals.map(sig => {
              const color = SEVERITY_COLORS[sig.severity] || '#64748b';
              return (
                <div
                  key={sig._id}
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: 10,
                    padding: '10px 12px',
                    background: '#fff',
                    border: `1px solid ${color}30`,
                    borderRadius: 8,
                    borderLeft: `3px solid ${color}`,
                  }}
                >
                  <span style={{ width: 7, height: 7, borderRadius: '50%', background: color, flexShrink: 0, marginTop: 4 }} />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: S.textPrimary }}>{sig.title}</div>
                    <div style={{ fontSize: 12, color: S.textMuted, marginTop: 2 }}>{sig.description}</div>
                  </div>
                  <span
                    style={{
                      fontSize: 10,
                      fontWeight: 700,
                      textTransform: 'uppercase',
                      color,
                      background: color + '12',
                      padding: '2px 8px',
                      borderRadius: 4,
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {sig.severity}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {/* Summary card */}
      <div
        style={{
          background: S.bgCard,
          border: `1px solid ${S.borderLight}`,
          borderRadius: 14,
          padding: '20px 24px',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr 1fr',
          gap: 20,
        }}
      >
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, color: S.textMuted, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 4 }}>{t('screens.claimsScreen.detail.policy')}</div>
          <div style={{ fontSize: 14, fontWeight: 600, color: S.burgundy }}>{claim.policyNumber || '—'}</div>
          <div style={{ fontSize: 12, color: S.textMuted, marginTop: 2 }}>{claim.lob}</div>
        </div>
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, color: S.textMuted, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 4 }}>{t('screens.claimsScreen.detail.lossDate')}</div>
          <div style={{ fontSize: 14, fontWeight: 600, color: S.textPrimary }}>{formatDate(claim.lossDate)}</div>
          <div style={{ fontSize: 12, color: S.textMuted, marginTop: 2 }}>{t('screens.claimsScreen.detail.filed', { date: formatDate(claim.filed) })}</div>
          {/* Ingestion date, shown only when it differs from the reported date
              by more than a day — i.e. for records loaded through the
              historical import. On a case reported into Regure directly the
              two are the same moment and a second date would be noise.
              Stating it explicitly is what lets the header carry a business
              chronology without hiding that the record arrived later. */}
          {(() => {
            if (!claim.ingestedAt || !claim.filed) return null;
            const gapMs = new Date(claim.ingestedAt).getTime() - new Date(claim.filed).getTime();
            if (!Number.isFinite(gapMs) || gapMs < 24 * 60 * 60 * 1000) return null;
            return (
              <div style={{ fontSize: 11, color: S.textMuted, marginTop: 2, fontStyle: 'italic' }}>
                {t('screens.claimsScreen.detail.ingested', { date: formatDate(claim.ingestedAt) })}
              </div>
            );
          })()}
        </div>
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, color: S.textMuted, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 4 }}>{t('screens.claimsScreen.detail.reserve')}</div>
          <div style={{ fontSize: 14, fontWeight: 600, color: S.textPrimary }}>{formatCurrency(claim.reserve)}</div>
          <div style={{ fontSize: 12, color: S.textMuted, marginTop: 2 }}>{t('screens.claimsScreen.detail.paid', { amount: formatCurrency(claim.paidAmount || 0) })}</div>
        </div>
        <div>
          <div style={{ fontSize: 11, fontWeight: 600, color: S.textMuted, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 4 }}>{t('screens.claimsScreen.detail.assignedTo')}</div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 2 }}>
            {claim.assigned ? (
              <>
                <div
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: 8,
                    background: `linear-gradient(135deg, ${S.burgundy}, ${S.burgundy2})`,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#fff',
                    fontSize: 11,
                    fontWeight: 700,
                  }}
                >
                  {claim.assignedInitials}
                </div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: S.textPrimary }}>{claim.assigned}</div>
                  <div style={{ fontSize: 12, color: S.textMuted }}>{t('screens.claimsScreen.senior')}</div>
                </div>
              </>
            ) : (
              <span style={{ fontSize: 13, color: '#d97706', fontStyle: 'italic' }}>{t('screens.claimsScreen.detail.unassigned')}</span>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header